const tabs = document.querySelectorAll('[data-tab-target]')
const tabContents = document.querySelectorAll('[data-tab-content]')

// Set first tab active by default
if (tabs.length > 0) {
  const firstTab = tabs[0]
  const firstTarget = document.querySelector(firstTab.dataset.tabTarget)

  firstTab.classList.add('active')
  if (firstTarget) firstTarget.classList.add('active')
}

tabs.forEach(tab => {
  tab.addEventListener('click', () => {
    const target = document.querySelector(tab.dataset.tabTarget)

    tabContents.forEach(tabContent => {
      tabContent.classList.remove('active')
    })

    tabs.forEach(tab => {
      tab.classList.remove('active')
    })

    tab.classList.add('active')
    target.classList.add('active')
  })
})
